import {APICore} from "./apiCore";

const api = new APICore(`${process.env.REACT_APP_IGNITION_API}/` || "https://dev.ignition-api.motorenn.com/");

// UPDATE
export const updateOrderPayment = async (id: number, data: any) => (await api.updatePatch(`orders/${id}/payments`, data)).data;
